import { uniqBy } from "ramda"
import { $whiteLabel } from "@callcenter/white-label"

const FONT_VARIANTS = [
  { label: "Graphik", value: "Graphik" },
  { label: "KalniaGlaze", value: "KalniaGlaze" },
  { label: "ChakraPetch", value: "ChakraPetch" },
  { label: "Monocraft", value: "Monocraft" },
  { label: "Manrope", value: "Manrope" }
]

export const createFontVariants = () => {
  const { themeFont } = $whiteLabel.getWhiteLabelSettings()

  if (!themeFont) {
    return FONT_VARIANTS
  }

  return uniqBy(({ value }) => value, [{ label: themeFont, value: themeFont }, ...FONT_VARIANTS])
}
